import { useQuery } from '@tanstack/react-query';
import api from 'api';
import { getMixpanelErrorProps } from 'axiosUtils';
import { FIRST_PAGE, MAX_LIMIT } from 'data/global';
import useGetMixpanelProps from 'hooks/useGetMixpanelProps';
import { DealRoom } from 'models/DealRoom';
import { ErrorViewedProps } from 'models/MixpanelEvents';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import { useContext } from 'react';
import mixpanelService from 'services/mixpanelService';

export const ENTERPRISE_SUGGESTED_ACTIONS_DEALS_QUERY_KEY =
  'enterprise-suggested-actions-deals';

export default function useEnterpriseDealsQuery(enterpriseId?: string) {
  const { isSuperAdmin } = useContext(CurrentUserContext);

  const getMixpanelProps = useGetMixpanelProps();

  return useQuery<DealRoom[]>({
    queryKey: [ENTERPRISE_SUGGESTED_ACTIONS_DEALS_QUERY_KEY, { enterpriseId }],
    queryFn: async () => {
      const {
        data: { items },
      } = await api.enterpriseAnalytics.getAllDeals(enterpriseId, {
        $page: FIRST_PAGE,
        $limit: MAX_LIMIT,
        onlyMyDeals: !isSuperAdmin,
      });

      return items;
    },
    onError: (error) =>
      mixpanelService.errorViewed(
        getMixpanelProps(getMixpanelErrorProps(error)) as ErrorViewedProps,
      ),
    enabled: !!enterpriseId,
  });
}
